<template>
  <ul class="Report report_layout">
    <keep-alive>
      <component :is="`ReportPreview`" :patientInfoProps="patientInfoProps" :selectCompNo="selectCompNo" @updateCompNo="updateCompNo"/>
    </keep-alive>
    <keep-alive>
      <component :is="'ReportItem'" :patientInfoProps="patientInfoProps" :selectCompNo="selectCompNo"/>
    </keep-alive>
  </ul>
</template>
<script>
    import ReportPreview from './reportPreview/index'
    import ReportItem from './reportItem/index'

    export default {
        name: '',
        components: {ReportPreview, ReportItem},
        props: ['patientInfoProps'],
        data() {
            return {
                selectCompNo: -1
            }
        },
        methods : {
            updateCompNo( no ) {
                this.selectCompNo = no;
            }
        }
    }
</script>
<style lang="scss">
  .report_layout {
    display: flex;
    height: 100%;
    min-height: 670px;

    .report_section_li {
      float: left;
      width: 540px;
      background: #fff;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      margin: 5px;
      position: relative;

      &:nth-child(2) {
        width: calc(100% - 360px);
        float: right;
      }

      .bottom_area_left {
        position: absolute;
        bottom: 20px;
        width: 100%;
        padding: 0 35px;
      }
    }

    .report_item_section_li {
       .section_report {
         box-shadow: none;
       }
    }
    .section_body {
      .columns_4 {
        align-items: baseline;
      }
    }
  }
</style>